import { formatAmountInr } from 'businesslogic/utils/common/functions'
import React from 'react'
import OrderDetails from '../../../../featureComponent/OrderAuth/OrderDetails/OrderDetails'

const Redeem = ({orders = []}) => {
  return (
    <div>
    {orders.map((order, index) => (
      <OrderDetails
        key={index}
        fundName={order.name}
        iconSrc={order.amc_logo_small}
        footerProps={{
          amount: formatAmountInr(order.amount),
          units: order.units,
        }}
      />
    ))}
  </div>
  )
}

export default Redeem